<template>
  <v-app>
    <Def>
      <v-container
        fluid
        z-index="2"
        style="position:absolute; width:90%; margin-left:5%"
        class="pr-8"
      >
        <v-row style="margin-top:100px">
          <v-col cols="8" class="d-none d-lg-flex font-weight-black pa-0">
            <p
              style="letter-spacing: 0.1em; font-size:4vw; line-height: 1.2em;font-family: Georgia, 'Times New Roman', Times, serif;"
            >
              Регистрируйся и
              <br />открывай
              <br />для себя новые
              <br />возможности
            </p>
          </v-col>
          <v-col lg="4" xs="12" class="pa-0">
            <v-row>
              <v-col xs="12" class="pa-0 pr-3">
                <v-radio-group v-model="reg.polz" :mandatory="false" row>
                  <v-radio label="Студент" value="1"></v-radio>
                  <v-radio label="ВУЗ" value="2"></v-radio>
                  <v-radio label="Компания" value="3"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2">Введите ваше имя</v-main>
                <v-text-field
                  v-model="name"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col md="6" xs="12" class="pa-0 pl-3">
                <v-main class="mb-2 d-none d-lg-flex">Введите вашу фамилию</v-main>
                <v-main class="mb-2 d-xs-flex d-lg-none">Ваша фамилия</v-main>
                <v-text-field
                  v-model="lastname"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col md="7" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2">Введите ваше отчество</v-main>
                <v-text-field
                  v-model="otc"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="reg.polz == 2">
              <v-col md="8" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2 d-none d-lg-flex">Введите название ВУЗа</v-main>
                <v-main class="mb-2 d-xs-flex d-lg-none">Название ВУЗа</v-main>
                <v-text-field
                  v-model="reg.Org"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="reg.polz == 3">
              <v-col md="8" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2 d-none d-lg-flex">Введите название организации</v-main>
                <v-main class="mb-2 d-xs-flex d-lg-none">Название организации</v-main>
                <v-text-field
                  v-model="reg.Org"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="8" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2">Ваш Email</v-main>
                <v-text-field
                  v-model="reg.email"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="8" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2">Контактный телефон</v-main>
                <v-text-field
                  v-model="reg.nomberPhone"
                  color="blue"
                  background-color="grey lighten-1"
                  clearable
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="7" xs="12" class="pa-0 pr-3">
                <v-main class="mb-2">Придумайте пароль</v-main>
                <v-text-field
                  v-model="reg.password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                  color="blue"
                  background-color="grey lighten-1"
                  dense
                  class="rounded-xl"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0 pr-3">
                <v-container fluid class="pa-0">
                  <v-col cols="12" class="pa-0">
                    <v-row justify="end">
                      <v-btn
                        depressed
                        class="text-body-2 text-capitalize"
                        rounded
                        width="40%"
                        color="#FFCF36"
                        @click="regs()"
                      >Зарегистрироваться</v-btn>
                    </v-row>
                    <v-row justify="end">
                      <div class="mt-3 pr-4">
                        <div class="text-body-2 d-inline">Уже есть аккунт?</div>
                        <div class="d-inline">
                          <v-btn
                            justify="start"
                            text
                            dense
                            small
                            class="text-body-2 text-capitalize font-weight-bold"
                          >Войти</v-btn>
                        </div>
                      </div>
                    </v-row>
                  </v-col>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <div z-index="1">
        <img
          src="../Assets/Reg.jpg"
          width="70%"
          class="d-none d-lg-inline-flex"
          style="margin-left:7%; margin-top:14%"
        />
      </div>
    </Def>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    show1: false,
    reg: {
      password: "",
      polz: "1",
      fio: "",
      Org: "",
      email: "",
      nomberPhone: "",
    },
    name: "",
    lastname: "",
    otc: "",
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match",
    },
  }),
  methods: {
    regs() {
      this.reg.fio = this.lastname + "_" + this.name + "_" + this.otc;
      for (var i in this.reg) {
        if (this.reg[i] == "") {
          delete this.reg[i];
        }
      }
      this.$ls.set("newpol", this.reg);
      this.$router.push("/?m=success");
    },
  },
  created() {
    if (this.$ls.get("inAk") == "true") {
      this.$router.replace("/");
    }
  },
};
</script>